import { fromJS, List } from 'immutable';

export const ADD_DESIGN = 'kroost/design/ADD_DESIGN';

// Initial routing state
const initialState = List();

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_DESIGN:
      return state.push(fromJS(action.design));
    default:
      return state;
  }
}

export function add(design) {
  return {
    type: ADD_DESIGN,
    design,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/designs.js